import { Clock, Loader2, AlertCircle } from 'lucide-react';
import { Button } from '@zaogig/ui/button';

interface IdlePhaseProps {
  onStart: () => void;
  locationLoading: boolean;
  locationError?: { message: string } | null;
}

export function IdlePhase({ onStart, locationLoading, locationError }: IdlePhaseProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-6">
      <div className="w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center mb-6">
        <Clock className="w-12 h-12 text-blue-600" />
      </div>
      <h2 className="text-xl font-bold text-gray-800 mb-2">任务型考勤</h2>
      <p className="text-gray-500 text-center mb-8">
        通过回答任务问题确认上岗，工作总结完成下班
      </p>

      <Button
        onClick={onStart}
        className="w-full bg-blue-600 hover:bg-blue-700"
        disabled={locationLoading}
      >
        {locationLoading ? (
          <>
            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
            获取位置中...
          </>
        ) : (
          '开始上班打卡'
        )}
      </Button>

      {locationError && (
        <div className="mt-4 flex items-center gap-2 text-red-500 text-sm">
          <AlertCircle className="w-4 h-4" />
          <span>{locationError.message}</span>
        </div>
      )}
    </div>
  );
}
